var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDropUp16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_drop_up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/navigation/arrow_drop_up_24px",
    d: "M4.66667 9.66667L8 6.33333L11.3333 9.66667H4.66667Z",
    fill: "#696F88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropUp16);
export default __webpack_public_path__ + "static/media/arrow-drop-up-16.594513f7a8025c0fb33e0735a3e6f037.svg";
export { ForwardRef as ReactComponent };